import * as React from 'react';
import clsx from 'clsx';
import { ArrowLeft, CornerDownRight, CreditCard, RefreshCcw } from 'lucide-react';
import { useTranslator } from '@gandi/translate';
import { Base, Button, Alert } from '@gandi/ui';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { ListBlock } from './ListBlock';
import { OrderStatusHeader } from './OrderStatusHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "PaymentFailed-root_1RvOz",
  "title": "PaymentFailed-title_3kMqO"
};
function Row({
  icon: Icon,
  content
}) {
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    gap: "small",
    flexWrap: true,
    children: [/*#__PURE__*/_jsx(Icon, {}), content]
  }, content);
}
export default function PaymentFailed({
  className,
  retryURL
}) {
  const FFShopConfirmationNDS = useFeatureFlag('FF_SHOP_CONFIRMATION_NDS');
  const {
    __
  } = useTranslator();
  if (FFShopConfirmationNDS) {
    const list = [{
      icon: CreditCard,
      content: __('Use a different payment method')
    }, {
      icon: RefreshCcw,
      content: __('Try again, as this may be a temporary issue.')
    }, {
      icon: CornerDownRight,
      content: __('Contact your bank to find out why your payment was declined.')
    }];
    return /*#__PURE__*/_jsxs("div", {
      className: clsx(styles.root, className),
      children: [/*#__PURE__*/_jsx(OrderStatusHeader, {
        icon: "error",
        title: __('Sorry, payment failed!'),
        content: __('We were unable to process your order.')
      }), /*#__PURE__*/_jsxs("section", {
        children: [/*#__PURE__*/_jsx(Base, {
          className: styles.title,
          tagName: "h2",
          margin: "none",
          children: __('We recommend that you:')
        }), /*#__PURE__*/_jsx(ListBlock, {
          children: list.map(Row)
        }), retryURL && /*#__PURE__*/_jsxs(Button, {
          href: retryURL,
          children: [/*#__PURE__*/_jsx(ArrowLeft, {}), __('Use another payment method')]
        })]
      })]
    });
  }
  const messages = [];
  messages.push( /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: __('#### Our online banking partner refused your payment.' + '\n' + 'We could not process your payment. We recommend that you:' + '\n' + '- Use another payment method if you think that your bank does not handle the "Verified by Visa protocol"' + '\n' + '- Try again if it might just be a temporary problem' + '\n' + '- Contact your bank to see why your payment was refused.', {
      withMarkdown: true
    })
  }, "message"));
  if (retryURL) {
    messages.push( /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: __('<p style="text-align: center; padding-top: 20px;">' + '<a href="%(retryURL)s" class="btn btn-color-main btn-outline">' + 'Use another payment method' + '</a>' + '</p>', {
        withHTML: true,
        retryURL
      })
    }, "additional"));
  }
  return /*#__PURE__*/_jsx(Base, {
    marginBottom: "base",
    children: /*#__PURE__*/_jsx(Alert, {
      message: messages,
      intent: "danger"
    })
  });
}